import { Theme } from '@mui/material/styles';
import { GroupBase, Props } from 'react-select';
import { CreatableProps } from 'react-select/creatable';

// Custom props passed to react-select components
export interface CustomSelectProps {
  label?: string;
  isFocused?: boolean;
  isError?: boolean;
  isNarrow?: boolean;
  muiTheme?: Theme;
  onEditClick?: (options?: unknown) => void;
  variant?: 'primary' | 'secondary';
  addText?: string;
  onAddClick?: () => void;
  isSub?: boolean;
}

// Extended selectProps type - use this when accessing custom props
export type SelectPropsWithCustom<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
> = Props<Option, IsMulti, Group> & CustomSelectProps;

// Helper to get typed selectProps - single place for the type coercion
export const sp = <T extends { selectProps: unknown }>(props: T): SelectPropsWithCustom =>
  props.selectProps as SelectPropsWithCustom;

// Type helper for CreatableSelect with custom props
export type CreatableSelectProps<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
> = CreatableProps<Option, IsMulti, Group> & CustomSelectProps;
